@if (currencies) {
<mat-select
    (selectionChange)="onChange($event)"
    [(value)]="selectedCurrency"
    panelClass="currency-selector-opts-panel"
    [disableOptionCentering]="true"
    hideSingleSelectionIndicator
    #selectRef
>
    @for (opt of currencies; track opt) {
    <mat-option [value]="opt.code">
        @if (opt.flag) {
        <span class="fi fi-{{ opt.flag }}"></span>
        }
        {{ opt.char }} {{ opt.code }}
    </mat-option>
    }
</mat-select>
}
